import React, { useState } from "react";
import "./../styles/Schedule.css";

const shows = [
  { id: 1, image: "1.png" },
  { id: 2, image: "2.png" },
  { id: 3, image: "3.png" },
  { id: 4, image: "4.png" },
  { id: 5, image: "5.png" },
  { id: 6, image: "7.png" },
];

export default function Schedule() {
  const [selectedShow, setSelectedShow] = useState(null);

  return (
    <section className="schedule-page">
      <div className="schedule-card">
        <div className="section-title-row">
          <h1 className="schedule-title">Schedule</h1>
        </div>

        <div className="schedule-panel">
          <div className="schedule-grid">
            {shows.map((show) => (
              <button
                type="button"
                key={show.id}
                className="show-card"
                onClick={() => setSelectedShow(show)}
                aria-label={`Open cover ${show.id}`}
              >
                <img
                  src={process.env.PUBLIC_URL + "/" + show.image}
                  alt={`Program cover ${show.id}`}
                />
              </button>
            ))}
          </div>
        </div>
      </div>

      {selectedShow && (
        <div
          className="schedule-modal-backdrop"
          onClick={() => setSelectedShow(null)}
          role="presentation"
        >
          <div
            className="schedule-modal"
            onClick={(event) => event.stopPropagation()}
            role="dialog"
            aria-modal="true"
            aria-label="Program cover detail"
          >
            <button
              type="button"
              className="schedule-modal-close"
              onClick={() => setSelectedShow(null)}
              aria-label="Close popup"
            >
              ×
            </button>

            <div className="schedule-modal-art">
              <img
                src={process.env.PUBLIC_URL + "/" + selectedShow.image}
                alt="Program cover detail"
              />
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
